/**
 * @author      esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IconProps } from '../../types'

interface AvatarIconProps extends IconProps {
  avatarFill?: string
  circleFill?: string
}

export const UserAvatar = ({
  size = 20,
  circleFill = '#80A4B5',
  avatarFill = '#fff',
  ...rest
}: AvatarIconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g style={{ mixBlendMode: 'multiply' }}>
        <circle cx="10" cy="10" fill={circleFill} r="10" />
      </g>
      <path
        d="M10 10C8.625 10 7.5 9 7.5 7.77778V7.22222C7.5 6 8.625 5 10 5C11.375 5 12.5 6 12.5 7.22222V7.77778C12.5 9 11.375 10 10 10Z"
        fill={avatarFill}
      />
      <path
        d="M11.4286 11.4285H8.57143C6.57143 11.4285 5 12.6856 5 14.2856H15C15 12.6856 13.4286 11.4285 11.4286 11.4285Z"
        fill={avatarFill}
      />
      <path
        d="M10 17.1428C8 17.1428 5 15.8775 5 14.2857H10H15C15 15.8775 12 17.1428 10 17.1428Z"
        fill={avatarFill}
      />
    </svg>
  )
}
